// extracted by css-extract-rspack-plugin
export default {"cls1":"ThreeImages-cls1_r43","cls2":"ThreeImages-cls2_wel ThreeImages-cls1_r43"};